import { CommonModule } from '@angular/common';
import { Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { HOME_BOXES } from '../../constants/general.constants';
import { faHome } from '@fortawesome/pro-duotone-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { filter } from 'rxjs';
import { PermissionService } from '../../services/permission.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: true,
  imports: [CommonModule, FontAwesomeModule, RouterModule]
})
export class SidebarComponent implements OnInit {
  @Input() isMenuOpen: boolean = false;

  itemsMenu: any[] = [];

  private readonly destroyRef = inject(DestroyRef);

  constructor(private permissionService: PermissionService, private router: Router) {}

  ngOnInit() {
    this.buildMenu();
    // El sidebar vive también en la pantalla de login: sin recalcular al navegar, tras iniciar sesión
    // (o cambiar de usuario) el menú se quedaba con las secciones de antes.
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd), takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.buildMenu());
  }

  private buildMenu() {
    const allowedBoxes = HOME_BOXES.filter(box =>
      this.permissionService.hasPermission(box.requiredPermission)
    );

    this.itemsMenu = [
      {
        boxes: [{
          name: 'Inicio',
          routerLink: '/home',
          icon: faHome
        }]
      },
      {
        boxes: allowedBoxes
      }
    ];
  }

  isActiveLink(item: any) {
    return window.location.pathname.includes(item.routerLink);
  }
}
